import { useEffect, useState } from "react";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { getSearchQuery } from "Utils/globals";

export function useEntrance(
  initial?: INSURANCE_NAME_VALUE,
): INSURANCE_NAME_VALUE | null {
  const [entrance, setEntrance] = useState(initial || null);
  const query = getSearchQuery();

  useEffect(() => {
    if (query.has("entrance")) {
      setEntrance(() => query.get("entrance") as INSURANCE_NAME_VALUE | null);
    }
  }, [query, setEntrance]);

  return entrance || null;
}
